export const TOP_HEADER_OBJECTS = [
    { link: "/", text: "Home" },
    { link: "/about-us/", text: "FOSO" },
    { link: "/plans/", text: "Plans" },
    { link: "/contact-us/", text: "Contact Us" },
];